type GAEvent = {
  eventCategory: string;
  eventAction: string;
  eventLabel?: string;
  eventValue?: number;
};

export interface GAWindow extends Window {
  ga?: Function;
}

export function sendPageview(page: string) {
  ga('set', 'page', page);
  ga('send', 'pageview');
}

export function sendEvent(event: GAEvent) {
  ga('send', 'event', event);
}

export function setUserId(userId: string) {
  ga('set', 'userId', userId);
}

export function setEmployee(isEmployee: boolean) {
  ga('set', 'dimension1', isEmployee ? 'internal' : 'external');
}

export function setAccess(hasAccess: boolean) {
  ga('set', 'dimension3', hasAccess ? 'Yes' : 'No');
}

export function setLastVisitedArtist(artistId: string) {
  ga('set', 'dimension4', artistId);
}

const _window: GAWindow = window;

export function ga(...args: any[]) {
  if (_window.ga) {
    _window.ga(...args);
  }
}

if (process.env.REACT_APP_GOOGLE_ANALYTICS_TOKEN) {
  init();
  ga('create', process.env.REACT_APP_GOOGLE_ANALYTICS_TOKEN, 'auto', {
    siteSpeedSampleRate: 10,
  });
  ga('set', 'anonymizeIp', true);
  ga('require', 'displayfeatures');
  ga('set', 'dimension2', 'isNotFive'); // legacy dimension
}

/* eslint-disable */
/* prettier-ignore */
export function init() {
  //  @ts-ignore
  (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
  //  @ts-ignore
  (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
  //  @ts-ignore
  m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
  //  @ts-ignore
  })(window,document,'script','https://www.google-analytics.com/analytics.js','ga');
}
/* eslint-enable */
